export type SkyTargetKind = "星座" | "明るい星";

export interface SkyTargetInfo {
  kind: SkyTargetKind;
  description: string;
}

export const SKY_TARGET_INFO: Record<string, SkyTargetInfo> = {
  "オリオン座": { kind: "星座", description: "冬を代表する星座。中央に3つ並ぶ『三つ星』が目印で、赤いベテルギウスと青白いリゲルも見つけやすい星です。" },
  "おうし座": { kind: "星座", description: "冬の星座。オレンジ色のアルデバランと、V字形に並ぶ星々を手がかりに探せます。" },
  "ふたご座": { kind: "星座", description: "冬の星座。カストルとポルックスという2つの明るい星が、双子の頭のように並びます。" },
  "おおいぬ座": { kind: "星座", description: "冬の南の空に見える星座。全天で最も明るい恒星シリウスが大きな目印です。" },
  "しし座": { kind: "星座", description: "春を代表する星座。『？』を裏返したような星の並びと、1等星レグルスが目印です。" },
  "おとめ座": { kind: "星座", description: "春の大きな星座。青白い1等星スピカを目印にすると見つけやすくなります。" },
  "うしかい座": { kind: "星座", description: "春から初夏の星座。オレンジ色に輝くアークトゥルスが目印で、春の大曲線の一部です。" },
  "さそり座": { kind: "星座", description: "夏の南の空を代表する星座。赤いアンタレスを中心に、S字形の星の並びが特徴です。" },
  "いて座": { kind: "星座", description: "夏の南の低い空に見える星座。天の川の濃い方向にあり、南斗六星やティーポット形の並びが目印です。" },
  "こと座": { kind: "星座", description: "夏の夜空で見つけやすい小さな星座。1等星ベガは七夕の織姫星で、夏の大三角の一角です。" },
  "わし座": { kind: "星座", description: "夏の天の川沿いにある星座。1等星アルタイルは七夕の彦星で、夏の大三角の一角です。" },
  "はくちょう座": { kind: "星座", description: "夏の天の川に沿って大きく広がる星座。デネブを尾に、十字形に並ぶ星々が白鳥の姿をつくります。" },
  "ペガスス座": { kind: "星座", description: "秋を代表する星座。4つの星がつくる大きな四角形『秋の四辺形』が見つける手がかりです。" },
  "アンドロメダ座": { kind: "星座", description: "秋の星座。ペガスス座の四辺形から星をたどると見つけやすく、暗い空ではアンドロメダ銀河も近くに見えます。" },
  "カシオペヤ座": { kind: "星座", description: "北の空に見えるW字形の星座。北極星を探す手がかりにもなる、形の分かりやすい星座です。" },
  "おおぐま座": { kind: "星座", description: "北の空に広がる大きな星座。尾と腰の部分にあたる7つの星が、よく知られた北斗七星です。" },
  "みずがめ座": { kind: "星座", description: "秋の南の空に広がる星座。明るい星は少ないため、暗い空で周囲の星座と一緒に探すのがおすすめです。" },
  "うお座": { kind: "星座", description: "秋の空に広がる星座。明るい星が少なく淡いので、街明かりの少ない場所ほど形をたどりやすくなります。" },

  "シリウス": { kind: "明るい星", description: "おおいぬ座の1等星で、太陽を除けば全天で最も明るく見える恒星。冬の夜空で強く白く輝きます。" },
  "カノープス": { kind: "明るい星", description: "りゅうこつ座の非常に明るい星。日本では南の地平線すれすれに見える地域が多く、見つけられる時間は限られます。" },
  "アークトゥルス": { kind: "明るい星", description: "うしかい座の1等星。オレンジ色が特徴で、北斗七星の柄を延ばす『春の大曲線』で探せます。" },
  "ベガ": { kind: "明るい星", description: "こと座の1等星で七夕の織姫星。アルタイル、デネブとともに『夏の大三角』をつくります。" },
  "カペラ": { kind: "明るい星", description: "ぎょしゃ座の1等星。冬の北東から高い空で黄色みを帯びて明るく輝きます。" },
  "リゲル": { kind: "明るい星", description: "オリオン座の右下に輝く青白い1等星。赤いベテルギウスとの色の違いも見どころです。" },
  "プロキオン": { kind: "明るい星", description: "こいぬ座の1等星。シリウス、ベテルギウスとともに『冬の大三角』をつくります。" },
  "ベテルギウス": { kind: "明るい星", description: "オリオン座の左上に輝く赤みのある1等星。シリウス、プロキオンと『冬の大三角』をつくります。" },
  "アルタイル": { kind: "明るい星", description: "わし座の1等星で七夕の彦星。ベガ、デネブとともに『夏の大三角』をつくります。" },
  "アルデバラン": { kind: "明るい星", description: "おうし座の1等星。オレンジ色に見え、V字形のヒアデス星団の近くで輝きます。" },
  "アンタレス": { kind: "明るい星", description: "さそり座の1等星。赤く輝くため『火星に対抗する星』という名を持ち、夏の南の空で目立ちます。" },
  "スピカ": { kind: "明るい星", description: "おとめ座の青白い1等星。北斗七星からアークトゥルスを経てたどる『春の大曲線』の先にあります。" },
  "ポルックス": { kind: "明るい星", description: "ふたご座の1等星。隣のカストルと並んで、双子の頭を表す明るい2星として見つけやすい星です。" },
  "フォーマルハウト": { kind: "明るい星", description: "みなみのうお座の1等星。秋の南の空で周囲に明るい星が少なく、『秋のひとつ星』とも呼ばれます。" },
  "デネブ": { kind: "明るい星", description: "はくちょう座の1等星で白鳥の尾にあたる星。ベガ、アルタイルと『夏の大三角』をつくります。" },
  "レグルス": { kind: "明るい星", description: "しし座の1等星。獅子の胸元にあたり、春の夜空でしし座を探す大きな目印になります。" },
  "カストル": { kind: "明るい星", description: "ふたご座の明るい星。ポルックスと並び、双子の頭を表す2つの星としてよく知られています。" },
  "ベラトリックス": { kind: "明るい星", description: "オリオン座の左上側、ベテルギウスと反対の肩に位置する青白い星。オリオンの形をたどる目印になります。" },
};
